import {shareLinkStyles} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink"; 
import { css } from "styled-components";

shareLinkStyles.wrapper = {
    css: css`
        margin-top: 30px;
        text-align: start;
        padding-right: 15px;
`,
}

shareLinkStyles.link = {
    link: {
        typographyProps: {
            weight: "bold",
        }
    }
}